import * as swcHelpers from '@swc/helpers';
import { toBaseLineItem } from './base-line-item.js';

const toRegularOrderLineItem = (orderLineItem, intl, options = {})=>{
    return swcHelpers.objectSpread({}, toBaseLineItem(orderLineItem, intl, options), {
        type: 'REGULAR',
        isSubscription: orderLineItem.isSubscription,
        subscriptionDetails: orderLineItem.subscriptionDetails || undefined
    });
};

export { toRegularOrderLineItem };
//# sourceMappingURL=regular-line-item.js.map
